import firebase from 'firebase/compat/app';
import 'firebase/compat/messaging';

const firebaseConfig = {
    apiKey: "AIzaSyB-pmFX7JX5W-KL7ES8J-kTUFa3VuLml6M",
    authDomain: "fitt-lab-studio.firebaseapp.com",
    projectId: "fitt-lab-studio",
    storageBucket: "fitt-lab-studio.firebasestorage.app",
    messagingSenderId: "471383649636",
    appId: "1:471383649636:web:e6c1818ce35268b8dede71",
    measurementId: "G-P1GF5PHVX1"
};

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}

export const messaging = firebase.messaging();
export default firebase;
